/**
 * Base URLs for the Ask REST endpoints.
 *
 * In local dev the auth + mcp-gateway hosts don't send CORS headers for the dev
 * origin, so we route through the Vite dev-server proxy (see web/vite.config.ts)
 * to make the browser requests same-origin. Staging/prod builds hit the real
 * hosts directly and depend on the servers returning proper CORS headers.
 */
export const ASK_AUTH_BASE_URL = import.meta.env.DEV
  ? '/__ask-auth'
  : import.meta.env.VITE_AUTH_URL;

export const ASK_GATEWAY_BASE_URL = import.meta.env.DEV
  ? '/__ask-gateway'
  : import.meta.env.VITE_MCP_GATEWAY_URL;
